import { render, staticRenderFns } from "./modaDialogl.vue?vue&type=template&id=47e2b198&scoped=true"
import script from "./modaDialogl.vue?vue&type=script&lang=js"
export * from "./modaDialogl.vue?vue&type=script&lang=js"
import style0 from "./modaDialogl.vue?vue&type=style&index=0&id=47e2b198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e2b198",
  null
  
)

export default component.exports